import {
  IntervalsLeft,
  TimerCircle,
  TimerClockDataContainer,
  TimerDigitsContainer,
} from './styledComponents'

export default function TimerClock({
  timerSeconds,
  children,
  topPadding = 'unset',
  backgroundImg,
  timerContainerStylesOverride = {},
  intervalsLeft,
  totalIntervals,
}) {
  const seconds = Math.floor(timerSeconds % 60)
  const minutes = Math.floor((timerSeconds / 60) % 60)

  return (
    <TimerCircle style={{ paddingTop: topPadding, ...timerContainerStylesOverride }}>
      <TimerClockDataComponent mins={minutes} seconds={seconds}>
        {children}
        {totalIntervals?.length > 0 && (
          <IntervalsLeft>
            <span className="no-margin-span">Intervals Left: </span>
            <span className="no-margin-span">{intervalsLeft?.length}</span>
          </IntervalsLeft>
        )}
      </TimerClockDataComponent>
    </TimerCircle>
  )
}

export function TimerClockDataComponent({ mins, seconds, children }) {
  return (
    <TimerClockDataContainer>
      <TimerDigitsContainer style={{ lineHeight: '65px' }}>
        {String(mins).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </TimerDigitsContainer>
      {children}
    </TimerClockDataContainer>
  )
}
